import React from "react";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MediaType } from "src/interfaces/Media";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";
import AssociationFieldPlaceholder from "./AssociationFieldPlaceholder";

const CoverSection: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("wizard-activity");
  const { t: tPicker } = useTranslation("media-library-picker");
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            color: theme.palette.text.primary,
          }}
        >
          {t("sections.cover.title")}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            color: theme.palette.text.primary,
            mt: 0.5,
          }}
        >
          {t("sections.cover.description")}
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <AssociationFieldPlaceholder
            label={t("fields.cover")}
            required
            value={data.cover_id}
            onChange={(next) => setData({ cover_id: next })}
            addLabel={t("common.add") || "Aggiungi"}
            emptyLabel={t("common.empty") || "Nessun elemento aggiunto"}
            error={!!errors.cover_id}
            errorMessage={
              errors.cover_id ? t(`errors.${errors.cover_id}`) || "" : ""
            }
            mediaType={MediaType.COVER}
            pickerTitle={tPicker("title-cover") || ""}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <AssociationFieldPlaceholder
            label={t("fields.video-cover")}
            value={data.video_id}
            onChange={(next) => setData({ video_id: next })}
            addLabel={t("common.add") || "Aggiungi"}
            emptyLabel={t("common.empty") || "Nessun elemento aggiunto"}
            mediaType={MediaType.VIDEO}
            pickerTitle={tPicker("title-video") || ""}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CoverSection;
